import {Button, Tooltip} from '@mui/material';
import React, { useState } from 'react';
import CustomSidebar from '../custom-sidebar/customSidebar';

const featureLogs=[
  {
    title: 'Version 2.1.7',
    description: 'Published Date: 28/09/2026',
    logs: [
      'Fixed a Cybersecurity device name appearing in the breadcrumb of unrelated risk assessment tasks.',
      'Shared assessment links now show the Summary, Attendance record, Assessment info and History buttons.',
      'Going back to a model from a shared link now lists only assessments of the same type.',
      'Shared links to Functional Safety events now open the Functional Safety view.',
    ],
  },
  {
    title: 'Version 2.1.6',
    description: 'Published Date: 01/09/2026',
    logs: [
      'Action item notification emails for Cybersecurity Risk Assessment devices now include a link that opens the device directly.',
      'Shared risk assessment links now show the full breadcrumb trail (product line and model).',
      'Saving a Cybersecurity Risk Assessment device now returns you to the device list.',
      'Renamed "Contact centre" to "Contact center" and "Policy Comment" to "Policy and Risk Response Comment" on device screens and in the spreadsheet export.',
    ],
  },
  {
    title: 'Version 2.1.5',
    description: 'Published Date: 28/08/2026',
    logs: [
      'Action items can now be tracked on Cybersecurity Risk Assessment devices, with the same assignment, due-date, and email notifications as other assessments.',
      'Added a Policy Comment field under the cybersecurity risk results, saved with the device and included in the spreadsheet export.',
      'Devices in a Cybersecurity Risk Assessment now have a status (Not Started, In Progress, Completed, Needs Review), editable on the device page and shown in the device list.',
    ],
  },
  {
    title: 'Version 2.1.4',
    description: 'Published Date: 16/06/2026',
    logs: [
      'Task status can now be set manually (Not Started, In Progress, Completed, Needs Review) from the Task Details and Add/Duplicate Task screens.',
      'Admins and Facilitators can edit task details and status; General users have read-only access.',
      'Task list now shows a colored status badge for every status.',
      'Spreadsheet export now includes a Status column, and the Completed column reflects the selected task status.',
      'Task filter now includes the Needs Review status.',
      'Significantly faster task list loading for risk assessments with many tasks.',
      'Returning from a Potential Unwanted Event now brings you back to the same place in the list.',
      'Fixed the exposure (Yes/No) selection occasionally reverting after being saved.',
    ],
  },
  {
    title: 'Version 2.1.3',
    description: 'Published Date: 11/06/2026',
    logs: [
      'Task completion status now exports correctly to the spreadsheet and matches the application.',
      'Assumptions now carry over from the application into the export spreadsheet.',
      'Added event status detail (e.g. No Exposure, Not Evaluated, Completed, In Progress) to the Potential Unwanted Events sheet.',
    ],
  },
  {
    title: 'Version 2.1.2',
    description: 'Published Date: 06/04/2026',
    logs: [
      'Event status now stays consistent between the task list and event details.',
      'Status remains correct after save and after page reload.',
      'Improved event detail behavior for Functional Safety workflows.',
      'General stability improvements for status display and save experience.',
    ],
  },
  {
    title: 'Version 2.1.1',
    description: 'Published Date: 20/02/2026',
    logs: [
      "When input, logic, and output are all Not Applicable, CCF is not considered for scoring and shows as Pass.",
    ],
  },
  {
    title: 'Version 2.1.0',
    description: 'Published Date: 03/02/2026',
    logs: [
      "Added CCF Not Applicable functionality",
    ],
  },
  {
    title: 'Version 2.0.9',
    description: 'Published Date: 24/01/2026',
    logs: [
     'Added CCF for Input/Logic/Output',
     'Enhanced Action Item email notifications with Product Line, Model, Risk Assessment, and Task information',
    ],
  },
  {
    title: 'Version 2.0.8',
    description: 'Published Date: 28/11/2025',
    logs: [
     'Added Description in CCF Option',
    ],
  },
  {
    title: 'Version 2.0.7',
    description: 'Published Date: 27/11/2025',
    logs: [
     'Added Import/Export Functional Safety Assessment  functionality',
    ],
  },
  {
    title: 'Version 2.0.6',
    description: 'Published Date: 25/11/2025',
    logs: [
     'Fixed Mpla Score Issue',
     'Added Discription in Failure mode',
     'Fixed Category Image Issue',
    ],
  },
  {
    title: 'Version 2.0.5',
    description: 'Published Date: 19/11/2025',
    logs: [
     'Enhanced Functional Safety assessment scoring functionality',
     'Added Import Risk Assessment from Excel file functionality',
    ],
  }
]
                 

const VersionTooltip = ({color = 'white'}) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.85)', // black with opacity
              color: 'white',
              fontSize: '13px',
              maxWidth: '300px',
              backdropFilter: 'blur(4px)', // optional blur for a soft effect
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5)', // adds depth
              borderRadius: '8px',
              padding: '10px',
            },
          },
        }}
        title={
          <div style={{fontSize: '12px'}}>
           {featureLogs[0].description}

            <ul
              style={{
                listStyleType: 'disc',
                paddingLeft: '20px',
              }}>

                {
                  featureLogs[0].logs.map((log) => (
                    <li key={log}>{log}</li>
                  ))
                }
               
             </ul>
          </div>
        }>
        <Button style={{color: color}} onClick={() => setOpen(true)}>{featureLogs[0].title}</Button>
      </Tooltip>

      <CustomSidebar heading="Version History"  open={open} onClose={() => setOpen(false)}>
        <div style={{padding: '10px',minWidth: '300px'}}>
        
          
          <div >
            {featureLogs.map((featureLog) => (
              <div key={featureLog.title}>
                <p style={{margin:0,padding:0,fontWeight: 'bold'}}>{featureLog.title}</p>
                <p style={{margin:0,padding:0}}>{featureLog.description}</p>
                <ul style={{maxWidth: '300px'}}>
                  {featureLog.logs.map((log) => (
                    <li key={log} style={{margin:0,padding:0}}>{log}</li>
                  ))}
                </ul>
                <hr/>
              </div>
            ))}
          </div>

        </div>
      </CustomSidebar>
    </div>
  );
};

export default VersionTooltip;



